import { ErrorHandler, NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { Router } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '@env/environment';

/**
 * notifications toasts.
 * @author Martin Batun Tec.
 */
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-alt-snotify';

/**
 * translate.
 * @author Martin Batun Tec.
 */
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function createTranslateLoader(http: HttpClient) {
  // return new TranslateHttpLoader(http, 'https://app-files-qf9ptb.s3.us-east-2.amazonaws.com/languages/', '.json');
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

/**
 * treo.
 * @author Martin Batun Tec.
 */
import { TreoModule } from '@treo/treo.module';
import { TreoConfigModule } from '@treo/services/config';
import { appConfig } from './app.config';

// Import the module from the SDK
import { AuthModule } from '@auth0/auth0-angular';
import { HttpConfigInterceptor } from '@services/api.service';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { SentryService } from '@services/sentry.service';
import { SentryFiltersService } from '@services/sentry-filters.service';
import { SentryErrorHandler } from './core/handlers/sentry-error-handler';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,

    // Treo & Treo Mock API
    TreoModule,
    TreoConfigModule.forRoot(appConfig),
    // TreoMockApiModule.forRoot(mockDataServices),

    SnotifyModule,
    MonacoEditorModule.forRoot(),

    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    // Import the module into the application, with configuration
    AuthModule.forRoot({
      domain: environment.authDomain,
      clientId: environment.authClientId,
      authorizationParams: {
        audience: environment.authAudience,
        scope: 'openid profile email',
        redirect_uri: window.location.origin,
      },
    }),
  ],
  providers: [
    // Sentry Services
    SentryService,
    SentryFiltersService,

    // HTTP Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },

    // Error Handler
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler,
    },

    // Sentry Trace Service
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },

    // Other Services
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService,
    provideEnvironmentNgxMask(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
